import { createContext, useContext, ReactNode } from "react";

type AnalyticsAttributes = {
    readonly eventColumn?: string;
    readonly eventComponent?: string;
    readonly eventContainer?: string;
    readonly parentLabel?: string;
    readonly labelEnglish?: string;
    readonly containerVariant?: string;
    readonly pageVariant?: string;
    readonly path?: string;
    readonly isIndexed?: boolean;
    readonly stack?: string;
};

export const AnalyticsAttributesContext = createContext<AnalyticsAttributes>(
    {}
);

export function useAnalyticsAttributes() {
    const context = useContext(AnalyticsAttributesContext);
    if (context === undefined) {
        throw new Error(
            "`useAnalyticsAttributes` must be used within a `AnalyticsContext.Provider`"
        );
    }
    return context;
}

export type AnalyticsAttributesProviderProps = {
    readonly value: AnalyticsAttributes;
    readonly children?: ReactNode;
};

export const AnalyticsAttributesProvider = ({
    value,
    children
}: AnalyticsAttributesProviderProps) => {
    const analyticsAttributes = useAnalyticsAttributes();
    return (
        <AnalyticsAttributesContext.Provider
            value={{ ...analyticsAttributes, ...value }}
        >
            {children}
        </AnalyticsAttributesContext.Provider>
    );
};
